import React from "react";
import { motion } from "framer-motion";
import { CustomTransition } from "../models/CustomTransition";

interface Props {
  visible: boolean;
  transition?: CustomTransition;
  className?: string;
}

const MotionGrowConnectorUp: React.FC<Props> = (props: Props): JSX.Element => {
  const growConnectorUp = {
    hidden: {
      height: "0%",
    },
    visible: {
      height: "100%",
      transition: {
        type: "tween",
        delay: props.transition ? props.transition.delay : undefined,
        duration: props.transition ? props.transition.duration : undefined,
      },
    },
  };

  return (
    <motion.div
      className={props.className}
      variants={growConnectorUp}
      initial={"hidden"}
      animate={props.visible ? "visible" : "hidden"}
    />
  );
};

export default MotionGrowConnectorUp;
